import { combineReducers }        from "redux";
import authenticationReducer      from "./Reducer_Authentication";
import aziendaReducer             from "./Reducer_Azienda";
import bilanciaReducer            from "./Reducer_Bilancia";
import campiPersonalizzatiReducer from "./Reducer_Campi";
import homeReducer                from "./Reducer_Home";
import impiantoReducer            from "./Reducer_Impianto";
import impostazioneReducer        from "./Reducer_Impostazioni";
import operatoreReducer           from "./Reducer_Operatore";
import pesataReducer              from "./Reducer_Pesata";
import tabellaReducer             from "./Reducer_Tabella";
import stampantiReducer           from "./Reducer_Stampanti";
import stampeReducer              from "./Reducer_Stampe";
import confermaEmailReducer       from "./Reducer_ConfermaEmail";
import holdingReducer             from "./Reducer_Holding";
import recoverReducer             from "./Reducer_RecuperaPassword";
import registrazioneReducer       from "./Reducer_Registrazione";
import upgradeReducer             from "./Reducer_Upgrade";
import indexReducer               from "./Reducer_Index";

const bilAppReducer = combineReducers({
  authenticationReducer,
  aziendaReducer,
  bilanciaReducer,
  campiPersonalizzatiReducer,
  homeReducer,
  impiantoReducer,
  impostazioneReducer,
  operatoreReducer,
  pesataReducer,
  tabellaReducer,
  stampantiReducer,
  stampeReducer,
  confermaEmailReducer,
  holdingReducer,
  recoverReducer,
  registrazioneReducer,
  upgradeReducer,
  indexReducer
});

export default bilAppReducer;



// WEBPACK FOOTER //
// ./src/Reducers/index.js